import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { useIntl } from "react-intl";
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookMessengerIcon, FacebookMessengerShareButton, FacebookShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
var shareButtonsCommonProps = {
  buttonProps: {
    className: "share-project__share-button"
  },
  iconProps: {
    className: "share-project__share-icon",
    path: "",
    // NOTE: required type
    round: true,
    // Whether to show round or rect icons (bool)
    size: 46 // Icon size in pixels (number)
    // borderRadius: Allow rounded corners if using rect icons (number)
    // bgStyle: customize background style, e.g. fill (object)
    // iconFillColor: customize icon fill color (string, default = 'white')

  }
};
export function ShareIcons(_ref) {
  var url = _ref.url;
  var intl = useIntl();
  return React.createElement("div", {
    className: "share-project__share-icons"
  }, React.createElement("div", {
    className: "share-project__share-icons-other"
  }, React.createElement(EmailShareButton, _extends({}, shareButtonsCommonProps.buttonProps, {
    url: url,
    subject: intl.formatMessage(_defineProperty({
      defaultMessage: "Sliding door project",
      "id": "components.OverlayManager.ShareProject.ShareIcons.3210609171"
    }, "id", "components.OverlayManager.ShareProject.ShareIcons.3210609171")) // (string): Title of the shared page
    ,
    body: intl.formatMessage(_defineProperty({
      defaultMessage: "My sliding door:",
      "id": "components.OverlayManager.ShareProject.ShareIcons.601393976"
    }, "id", "components.OverlayManager.ShareProject.ShareIcons.601393976")) // (string): Email, will be prepended to the url.
    // separator="separator" //  (string, default=" "): Separates body from the url

  }), React.createElement(EmailIcon, _extends({}, shareButtonsCommonProps.iconProps, {
    bgStyle: {
      fill: "#C34C3E"
    }
  }))), React.createElement(FacebookShareButton, _extends({}, shareButtonsCommonProps.buttonProps, {
    url: url,
    quote: "quote" // (string): A quote to be shared along with the link.
    ,
    hashtag: "hashtag" // hashtag (string): A hashtag specified by the developer to be added to the shared content. People will still have the opportunity to remove this hashtag in the dialog. The hashtag should include the hash symbol.

  }), React.createElement(FacebookIcon, shareButtonsCommonProps.iconProps)), React.createElement(FacebookMessengerShareButton, _extends({}, shareButtonsCommonProps.buttonProps, {
    url: url,
    appId: "" // (string): Facebook application id
    // redirectUri (string): The URL to redirect to after sharing (default: the shared url).
    // to (string): A user ID of a recipient. Once the dialog comes up, the sender can specify additional people as recipients.

  }), React.createElement(FacebookMessengerIcon, shareButtonsCommonProps.iconProps)), React.createElement(TwitterShareButton, _extends({}, shareButtonsCommonProps.buttonProps, {
    url: url,
    title: "title" // (string): Title of the shared page
    ,
    via: "via" // (string)
    ,
    hashtags: ["hashtags"] // (array): Hashtags
    // related:   (array): Accounts to recommend following

  }), React.createElement(TwitterIcon, shareButtonsCommonProps.iconProps)), React.createElement(WhatsappShareButton, _extends({}, shareButtonsCommonProps.buttonProps, {
    url: url,
    title: "title" // (string): Title of the shared page
    ,
    separator: "separator" // (string, default=" "): Separates title from the url

  }), React.createElement(WhatsappIcon, shareButtonsCommonProps.iconProps))));
}